import React, {useContext, useEffect} from "react";
import texts from './localization'
import LocaleContext from "Standard/LocaleContext";
import {localized} from "Standard/utils/localized";
import styled from "styled-components";
import Text from "components/Text";
import {JustifyStartColumn, Row} from "Standard/styles/GlobalStyledComponents";
import TrustButton from "Standard/components/TrustButton";
import {useNavigate} from "react-router-dom";
import {RouteName} from "router";
import {useUserAccountInfo} from "hooks/useUserAccountInfo";
import {API_URL} from "api/constants";
import NoPageError from "../../Standard/components/404";

type AccountPropType = {}

const AccountDefaultProps = {}

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 36px;
  width: 100%;

  @media (max-width: 640px) {
    padding: 24px;
  }
`

const CardWrapper = styled(JustifyStartColumn)`
  position: relative;
  width: 100%;
  max-width: 530px; 
  min-height: 275px;
  background: #FFFFFF;
  border: 1px solid rgba(24, 24, 51, 0.1);
  border-radius: 16px;
  margin-top: 25px;
  z-index: 1;
  
  @media (max-width: 768px) {
    max-width: 100%; 
  }
`

const ContactInformationBlock = styled(JustifyStartColumn)`
  width: 100%;
  padding: 32px;
  border-bottom: 1px solid rgba(24, 24, 51, .1);

  @media (max-width: 640px) {
    padding: 16px;
  }
`

const ChangeDataButton = styled.button`
  border: 0;
  background: none;
  text-decoration-line: underline;
  color: #5790FF;
  font-weight: 500;
  font-size: 16px;
  
  &:focus,
  &:active {
    outline: none
  }
  
  &:hover {
    color: rgba(87, 144, 255, .8)
  }
`

const DangerZoneBlock = styled(JustifyStartColumn)`
  padding: 32px;
`

const RowText = styled.div`
  display: flex;
  gap: 12px;
  justify-content: space-between;
`

const SpaceBetweenRow = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  width: 100%;

  @media (max-width: 640px) {
    flex-direction: column;
  }
`

const Account = (props: AccountPropType) => {
  const {locale} = useContext(LocaleContext)

  const {fetchUserAccountInfo, phone, email, communicationMethod, isServerError} = useUserAccountInfo(`${API_URL}/api/users/contacts`)

  const history = useNavigate()

  useEffect(() => {
    fetchUserAccountInfo()
  } , [])

  return (
    <>
      {isServerError && <NoPageError isServerError={isServerError}/>}
      {!isServerError &&  <Container>
        <Text fontWeight={600} fontSize={40}>{localized(texts.title, locale)}</Text>
        <CardWrapper>
          <ContactInformationBlock gap={16}>
            <Text fontWeight={600} fontSize={20}>{localized(texts.contactInformation, locale)}</Text>
            <SpaceBetweenRow>
              <Text fontWeight={500} fontSize={16}>{localized(texts.email, locale)}</Text>
              <RowText>
                <Text fontWeight={400} fontSize={16}>{email}</Text>
                <ChangeDataButton onClick={() => history(RouteName.CHANGE_EMAIL)}>{localized(texts.changeButton, locale)}</ChangeDataButton>
              </RowText>
            </SpaceBetweenRow>
            <SpaceBetweenRow>
              <Text fontWeight={500} fontSize={16}>{localized(texts.phone, locale)}</Text>
              <RowText>
                <Text fontWeight={400} fontSize={16}>
                  {phone ? phone : '-'}
                </Text>
                <ChangeDataButton onClick={() => history(RouteName.CHANGE_PHONE)}>{localized(texts.changeButton, locale)}</ChangeDataButton>
              </RowText>
            </SpaceBetweenRow>
            <SpaceBetweenRow>
              <Text fontWeight={500} fontSize={16}>{localized(texts.communicationMethod, locale)}</Text>
              <RowText>
                <Text fontWeight={400} fontSize={16}>
                  {communicationMethod ? communicationMethod.contact : '-'}
                </Text>
                <ChangeDataButton onClick={() => history(RouteName.CHANGE_COMMUNICATION_METHOD)}>{localized(texts.changeButton, locale)}</ChangeDataButton>
              </RowText>
            </SpaceBetweenRow>
          </ContactInformationBlock>
          <DangerZoneBlock gap={16}>
            <Text fontWeight={600} fontSize={20}>{localized(texts.dangerZone, locale)}</Text>
            <Row gap={8}>
              <TrustButton
                isValid
                style='black'
                rippleColor={'rgba(0, 0, 0, 0.2)'}
                onClick={() => history(RouteName.CHANGE_PASSWORD)}
              >
                {localized(texts.changePasswordButton, locale)}
              </TrustButton>
              {/*<TrustButton*/}
              {/*  isValid*/}
              {/*  style='red'*/}
              {/*  onClick={() => history(RouteName.DELETE_ACCOUNT)}*/}
              {/*>*/}
              {/*  {localized(texts.deleteAccountButton, locale)}*/}
              {/*</TrustButton>*/}
            </Row>
          </DangerZoneBlock>
        </CardWrapper>
      </Container>}
    </>
  )
};

Account.defaultProps = AccountDefaultProps

export default Account

